/*
import type { Dispatch as ReduxDispatch } from "redux";
import { store } from "./redux";

export let dispatch = async (action: Action) => {
    if (!store) {
        console.error("store not ready", action);
        return;
    }

    messageBus.setStoreSync();
    store.dispatch(action);
    await messageBus.sync();
};
export type Dispatch = ReduxDispatch<Action>;
*/

import type { Action, ActionMap } from "./actions";
import { TypedMessageBus } from "./typedMessageBus";

export const messageBus = new TypedMessageBus<ActionMap>();

export const dispatch = (message: Action) => messageBus.dispatch(message);

export * from "./useMessageBus";
